import React, { useEffect, useMemo, useState } from 'react';
import { Button, ButtonGroup, Modal, OptionInterface, Table, TablePagination, TablePreferences } from '@veneer/core';
import { useTranslation } from 'react-i18next';
import './../../assets/css/views/Sales/sales.css';
import SubRetailManagementLogic, { columnsWidth } from './SubRetailManagementLogic';
import CreateSubretailScreen from './createSubretailScreen'
import UpdateSubretailScreen from './updateSubRetailScreen';
import { FormFieldsSubRetail, ISubRetailIn } from '../../models/input/agendaApi/ISubRetail';
import LoaderModal from '../../components/Loader/loaderModal';

export default function SubRetailManagementMain() {
    const [t] = useTranslation("global");
    const { getSubRetailInformationList,
        dataSubRetailInformationList, loadingTable, loading, updateSubRetailModal, formPointOfSale, createSubRetailModal,
        formPointOfSaleUpdate, dataToUpdate, columns2, currentPage,
        insertSubRetail, setUpdateSubRetailModal, setFormPointOfSale, setCreateSubRetailModal, setFormPointOfSaleUpdate,
        updateSubRetail, setCurrentPage
    } = SubRetailManagementLogic();
    const [pageSize, setPageSize] = useState<number>(20);

    useEffect(() => {
        getSubRetailInformationList()
    }, [])

    const tablePreferences: TablePreferences = {
        width: columnsWidth,
    };

    
    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handlePageSizeChange = (
        event: React.MouseEvent<HTMLElement>,
        option: OptionInterface<number>
    ) => {
        setPageSize(option.value);
    };

    const paginationProps = useMemo(() => ({
        currentPage,
        onPageChange: handlePageChange,
        onPageSizeChange: handlePageSizeChange,
        pageSize,
        totalItems: dataSubRetailInformationList.length,
    }), [currentPage, pageSize, dataSubRetailInformationList.length]);

    const createSubRetail = () => {
        const params: ISubRetailIn = {
            "userID": 0,
            "subRetailID": 0,
            "countryID": Number(formPointOfSale.countryId[0]),
            "posFormatID": Number(formPointOfSale.formatPosID[0]),
            "tierID": Number(formPointOfSale.tierId[0]),
            "retailID": Number(formPointOfSale.retailId[0]),
            "nameRetail": formPointOfSale.nameRetail![0] ?? '',
            "nameCompany": formPointOfSale.companyId[0] ?? '',
            "nameSubretail": formPointOfSale.subRetailId[0] ?? ''
        }
        insertSubRetail(params);
    }

    const handlerupdateSubRetail = () => {
        const params: ISubRetailIn = {
            "userID": 0,
            "subRetailID": dataToUpdate.id_SubRetail,
            "countryID": Number(formPointOfSaleUpdate.countryId[0]),
            "posFormatID": Number(formPointOfSaleUpdate.formatPosID[0]),
            "tierID": Number(formPointOfSaleUpdate.tierId[0]),
            "retailID": Number(formPointOfSaleUpdate.retailId[0]),
            "nameRetail": formPointOfSaleUpdate.nameRetail![0] ?? '',
            "nameCompany": formPointOfSaleUpdate.companyId[0] ?? '',
            "nameSubretail": formPointOfSaleUpdate.subRetailId[0] ?? ''
        }
        updateSubRetail(params)
    }

    const isFormValid = (form: FormFieldsSubRetail) => {
        return Object.values(form).every(valueArray => valueArray.length > 0);
    };

    const firstValueSlice = ((currentPage - 1) * pageSize)
    const secondValueSlice = ((currentPage - 1) * pageSize + pageSize)
    return (
        <div className='containeraddPoint'>
            {/* Botón para agregar nuevo punto de venta */}
            <div className="addPoint">
                <Button onClick={() => setCreateSubRetailModal(true)}>
                    {t('subRetailManagement.addNewSubRetail')}
                </Button>
            </div>

            {/* Tabla de puntos de venta */}
            <Table
                behavior={{
                    type: 'singlePage',
                }}
                css={{
                    height: '78vh',
                }}
                columnResize
                loading={loadingTable}
                columns={columns2}
                data={dataSubRetailInformationList.slice(firstValueSlice, secondValueSlice)}
                loadingDataLength={5}
                preferences={tablePreferences}
                pagination={paginationProps}
                showFilters={true}
            />

            <div style={{ position: 'relative' }}>
                <Modal
                    className="modalBrandsConfirmDeletion"
                    align="center"
                    id="modalBrandsConfirmDeletion"
                    show={createSubRetailModal || updateSubRetailModal}
                    footer={(
                        <ButtonGroup className="modalBrandsConfirmDeletionButtonGroup">
                            <Button onClick={updateSubRetailModal ? handlerupdateSubRetail : createSubRetail}
                                disabled={!isFormValid(createSubRetailModal ? formPointOfSale : formPointOfSaleUpdate)}
                            >{t("header.save")}</Button>
                            <Button onClick={() => updateSubRetailModal ? setUpdateSubRetailModal(false) : setCreateSubRetailModal(false)} appearance="secondary">{t("header.cancel")}</Button>
                        </ButtonGroup>
                    )}
                    title={updateSubRetailModal ? t('subRetailManagement.updateSubRetail') : t('subRetailManagement.createSubRetail')}
                >
                    {!updateSubRetailModal ?
                        (<CreateSubretailScreen
                            setFormPointOfSale={setFormPointOfSale}
                            formPointOfSale={formPointOfSale} />)
                        :
                        (<UpdateSubretailScreen
                            setFormPointOfSaleUpdate={setFormPointOfSaleUpdate}
                            formPointOfSaleUpdate={formPointOfSaleUpdate}
                        />)
                    }
                    {loading &&
                        <div>
                            <LoaderModal >
                                <div> {t('modal.savingInformation')}</div>
                            </LoaderModal>
                        </div>
                    }
                </Modal>
            </div>
        </div>
    );
}
